import request from '@/common/request.js'
import {
	download
} from '@/common/request.js'
import config from "@/common/config.js"

// method 请求方式
// url 接口地址
// data 请求参数
// preventRepetition 是否防止重复请求 默认值 false

//退出登录
export function Logout(data = {}) {
	return request({
		method: 'get',
		url: `/api/user/logout`
	})
}

// 合作企业列表
export function CompanyListByCooperation(data = {}) {
	return request({
		method: 'get',
		url: `/permission/feign/gateway/aboutPlatform/listCompany`
	})
}

// 获证企业列表
export function CompanyListByCertificate(data = {}) {
	return request({
		method: 'get',
		url: `/permission/feign/gateway/home/listCompany`
	})
}

// 数据统计-首页顶部
export function TopStatistics(data = {}) {
	return request({
		method: 'get',
		url: `/permission/feign/gateway/home/topStatistics`
	})
}

// 轮播-首页顶部
export function BannerList(data = {}) {
	return request({
		method: 'get',
		url: `/permission/feign/gateway/home/listBanner`
	})
}

// 获取配置
export function ConfigValue(data = {}) {
	let {
		configKey = ''
	} = data
	return request({
		method: 'get',
		url: `/permission/feign/gateway/config/get?configKey=${configKey}`
	})
}

// 获取资讯详情
export function InformationDetails(data = {}) {
	let {
		id = ''
	} = data
	return request({
		method: 'get',
		url: `/manager/feign/information/getInformation/${id}`
	})
}

// // 获取资讯详情
// export function InformationDetails(data = {}) {
// 	let {
// 		id = ''
// 	} = data
// 	return request({
// 		method: 'get',
// 		url: `/manager/feign/information/page/next/{id}/{flag}`
// 	})
// }

// 获取资讯详情
export function PolicyDetails(data = {}) {
	let {
		id = ''
	} = data
	return request({
		method: 'get',
		url: `/manager/feign/policy/get/${id}`
	})
}

// 下载技术文件
export function DownPrc(data = {}) {
	let {
		id = ''
	} = data
	return request({
		method: 'get',
		url: `/oss/getFile/${id}`,
		usetoken: true,
		responseType: 'blob'
	})
}

// 获取用户信息
export function UsersDetail(data = {}) {
	return request({
		method: 'get',
		url: `/permission/users/detail`,
		usetoken: true
	})
}

// 退出登录
export function LogOut(data = {}) {
	return request({
		method: 'get',
		url: `/sso/oauth/out`,
		usetoken: true
	})
}

// 企业认证详情
export function FindOrg(data = {}) {
	return request({
		method: 'get',
		url: `/permission/orgAuth/auth/web/select`,
		usetoken: true
	})
}

// 资讯推荐
export function RecommendInformation(data = {}) {
	let {
		id = ''
	} = data
	return request({
		method: 'get',
		url: `/manager/feign/information/listRecommendInformation/${id}`,
	})
}

// 政策推荐
export function RecommendPolicy(data = {}) {
	let {
		id = ''
	} = data
	return request({
		method: 'get',
		url: `/manager/feign/policy/listRecommendPolicy/${id}`,
	})
}

// 单点登录地址
export function SingleSignOnUrl(data = {}) {
	return request({
		method: 'get',
		url: `/permission/users/singleSignOnUrl`,
		usetoken: true
	})
}

//平台资质
export function PlatformQualification(data = {}) {
	return request({
		method: 'get',
		url: `/permission/feign/platformQualification`
	})
}





//联系我们
export function AddContactUs(data = {}) {
	return request({
		method: 'post',
		url: `/permission/feign/addContactUs`,
		sendmsg: data,
	})
}

// 人机验证
export function ValidatePerson(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/sms/del`,
		sendmsg: data,
	})
}

// 忘记密码
export function ModifyPassword(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/forget/password`,
		sendmsg: data,
	})
}

// 验证短信验证码
export function ValidateSms(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/validation/sms`,
		sendmsg: data,
	})
}

// 我的留言-全部留言
export function QuestionsListByUser(data = {}) {
	return request({
		method: 'post',
		url: `/help/questions/n/listPage`,
		sendmsg: data,
		usetoken: true
	})
}

// 我的留言-未回复
export function NotRespondToQuestions(data = {}) {
	return request({
		method: 'post',
		url: `/help/questions/self/listPage`,
		sendmsg: data,
		usetoken: true
	})
}

// 我的留言-已回复
export function HasRepliedToQuestions(data = {}) {
	return request({
		method: 'post',
		url: `/help/questions/self/listPage/order/answer`,
		sendmsg: data,
		usetoken: true
	})
}

// 发送留言
export function SubmitQuestion(data = {}) {
	return request({
		method: 'post',
		url: `/help/questions/submitQuestion`,
		sendmsg: data,
		usetoken: true
	})
}

// 枚举接口
export function InternationalAreaCode(data = {}) {
	return request({
		method: 'post',
		url: `/permission/feign/basicCodeItem/listBySetCode`,
		sendmsg: data
	})
}

// 搜索
export function QueryPageFulltext(data = {}) {
	return request({
		method: 'post',
		url: `/manager/search/n/queryPageFulltext`,
		sendmsg: data
	})
}

// 企业认证申请
export function SaveOrg(data = {}) {
	return request({
		method: 'post',
		url: `/permission/orgAuth/saveOrgAuth`,
		sendmsg: data,
		usetoken: true
	})
}

// 企业注册认证申请
export function SaveOrgReg(data = {}) {
	return request({
		method: 'post',
		url: `/permission/feign/saveOrgAuth`,
		sendmsg: data,
	})
}

// 验证手机号是否注册
export function ValidatePhone(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/sign/validation/phone`,
		sendmsg: data
	})
}

// 登录
export function Login(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/login`,
		sendmsg: data
	})
}

// 技术文件详情
export function LcaCfpPcrManagementDetails(data = {}) {
	return request({
		method: 'post',
		url: `/manager/lcaCfpPcrManagement/detail`,
		sendmsg: data,
		usetoken: true
	})
}

// 资讯列表-首页
export function InformationListForHome(data = {}) {
	return request({
		method: 'post',
		url: `/manager/feign/information/page/list`,
		sendmsg: data
	})
}

// 产品目录
export function ProductDictionary(data = {}) {
	return request({
		method: 'post',
		url: `/manager/openYitanApi/getPcrProductDictionary`,
		sendmsg: data
	})
}

// 政策列表
export function PolicyList(data = {}) {
	return request({
		method: 'post',
		url: `/manager/feign/policy/page/list`,
		sendmsg: data
	})
}

// 政策分类
export function PolicyCode(data = {}) {
	return request({
		method: 'post',
		url: `/permission/feign/basicCodeItem/listBySetCode`,
		sendmsg: data
	})
}

// pcr列表
export function PcrList(data = {}) {
	return request({
		method: 'post',
		url: `/manager/feign/lcaCfpPcrManagement/getPage`,
		sendmsg: data
	})
}

// 获取问题列表
export function QuestionsList(data = {}) {
	return request({
		method: 'post',
		url: `/help/questions/n/listPage`,
		sendmsg: data
	})
}

// 获取资讯列表
export function InformationList(data = {}) {
	return request({
		method: 'post',
		url: `/manager/feign/information/page/list`,
		sendmsg: data
	})
}

// 获取资讯类型
export function InformationCode(data = {}) {
	return request({
		method: 'post',
		url: `/permission/feign/basicCodeItem/listBySetCode`,
		sendmsg: data
	})
}

// 滑块
export function NSlider(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/n/slider`,
		sendmsg: data
	})
}

// 验证码
export function SmsSend(data = {}) {
	return request({
		method: 'post',
		url: `/sso/oauth/sms/send`,
		sendmsg: data
	})
}

// 上传文件地址
export const UploadFileUrl = `${config.host}/oss/feign/upload/file`
